<div [attr.data-qa]="qaTag" class="modal-dialog">
    @if (showForm()) {
        <app-import-form-dialog #formDialog (closed)="close()" (formDone)="formDone($event)"
                                (formValidation)="formValid.set($event);" [data]="modalData"/>
        <div class="import-dialog-action-buttons">
            @if ((formValid() || modalData.documentId) && (files$ | async)?.length! > 0) {
                <app-button (clicked)="formDialog && formDialog.upload()"
                            [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                            [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                            [buttonText]="'BUTTON.OK' | translate"
                            [svgIcon]="ICONS.OK"
                            qaTag="start-upload-button"/>
            }
            <app-button (clicked)="close()"
                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="'BUTTON.CLOSE' | translate"
                        [svgIcon]="ICONS.CLOSE"
                        qaTag="close-import-file-selection-dialog"/>
        </div>
    } @else {
        <h2 [attr.data-qa]="qaTag + '-title'" class="modal-dialog-title">{{ 'IMPORT.' + ((importDone$ | async) ? 'IMPORTED' : 'IMPORTING') |translate }}</h2>
        <ul [attr.data-qa]="(importDone$ | async) ? 'import-job-finished': 'import-job-pending'" class="list">
            @for (statusFile of filesWithStatus(); track i; let i = $index) {
                @let upload = statusFile.upload();
                @if (upload) {
                    <li #item class="list-item">
                        <div [attr.data-qa]="'file-ext-icon-' + statusFile.file.name" class="list-item-icon">
                            <app-icon
                                    [iconSize]="AppIconSize.SMALL"
                                    [iconUrl]="{url: statusFile.iconId|apiIconUrl| authImage: { loadingElement: item }, fallback: ICONS.DOCUMENT}"/>
                        </div>
                        <div class="list-item-title-group">
                            <app-document-filename [appTestTag]="'status-file-name-' + statusFile.file.name"
                                                   [filename]="statusFile.file.name" class="list-item-text list-item-title"/>
                            <div [attr.data-qa]="'upload-status-' + statusFile.file.name" class="list-item-text list-item-subtitle">
                                @switch (upload.status) {
                                    @case (FileUploadStatusEnum.Waiting) {
                                        {{ 'IMPORT.WAIT_FOR_IMPORT' | translate }}
                                    }
                                    @case (FileUploadStatusEnum.Uploading) {
                                        {{ upload.progress }} %
                                    }
                                    @case (FileUploadStatusEnum.Downloading) {
                                        100 %
                                    }
                                    @case (FileUploadStatusEnum.Error) {
                                        @if (upload.error?.code; as errorCode) {
                                            <div [attr.data-qa]="'upload-error-message-' + i + 'with-error-code-' + errorCode"
                                                 class="upload-error-message">
                                                {{ 'ERROR.CODES.CODE_' + errorCode | translate }}
                                            </div>
                                        } @else {
                                            <div class="upload-error-message" data-qa="upload-error-message-unknown">
                                                {{ 'ERROR.CODES.CODE_0' | translate }}
                                            </div>
                                        }
                                    }
                                }
                            </div>
                        </div>
                        <div [attr.data-qa]="'upload-status-icon-' + statusFile.file.name" class="list-item-badges">
                            @switch (upload.status) {
                                @case (FileUploadStatusEnum.Waiting) {
                                    <app-icon [attr.data-qa]="'upload-status-icon-' + upload.status | kebabCase"
                                              [iconSize]="AppIconSize.SMALL"
                                              [svgIcon]="ICONS.HOURGLAS"
                                              class="hourglas-icon"/>
                                }
                                @case (FileUploadStatusEnum.Uploading) {
                                    <div [attr.data-qa]="'upload-status-icon-' + upload.status | kebabCase"
                                         class="loader">
                                    </div>
                                }
                                @case (FileUploadStatusEnum.Downloading) {
                                    <app-icon [attr.data-qa]="'upload-status-icon-' + upload.status | kebabCase"
                                              [iconSize]="AppIconSize.SMALL"
                                              [svgIcon]="ICONS.HOURGLAS"
                                              class="hourglas-icon"/>
                                }
                                @case (FileUploadStatusEnum.Error) {
                                    <app-icon [attr.data-qa]="'upload-status-icon-' + upload.status | kebabCase"
                                              [iconSize]="AppIconSize.SMALL"
                                              [svgIcon]="ICONS.THUMBS_DOWN"/>
                                }
                                @case (FileUploadStatusEnum.Done) {
                                    <app-icon [attr.data-qa]="'upload-status-icon-' + upload.status | kebabCase"
                                              [iconSize]="AppIconSize.SMALL"
                                              [svgIcon]="ICONS.THUMBS_UP"/>
                                }
                            }
                        </div>
                    </li>
                }
            }
        </ul>
        <div class="modal-dialog-action-icon-buttons" data-qa="import-dialog-actions">
            <app-button (clicked)="reset()"
                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="'BUTTON.ADD_MORE_DOCUMENTS' | translate"
                        [isDisabled]="(importDone$|async) === false"
                        [svgIcon]="ICONS.ADD_NEW"
                        qaTag="reset-import-dialog-button"/>
            <app-button (clicked)="close()"
                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="'BUTTON.CLOSE' | translate"
                        [svgIcon]="ICONS.OK"
                        qaTag="close-import-dialog-button"/>
        </div>
    }
</div>
